<!-- .block-products-carousel -->
<div
    class="block block-products-carousel"
    [ngClass]="{
        'block-products-carousel--loading': blockProductCarouselService.loading,
        'block-products-carousel--has-items': !!columns?.length
    }"
    [attr.data-layout]="'grid-'"
>
    <div>
        <app-block-header [name]="translateHelper.localize(name)" [arrows]="true" (next)="carousel.next()" (prev)="carousel.prev()"></app-block-header>

        <div class="block-products-carousel__slider">
            <div class="block-products-carousel__preloader"></div>

            <owl-carousel-o class="owl-slider-item" [options]="carouselOptions" appOwlPreventClick #carousel>
                <ng-template *ngFor="let column of columns" carouselSlide>
                    <div class="block-products-carousel__column">
                        <div *ngFor="let product of column" class="block-products-carousel__cell">
                            <app-product-card-new [product]="product" [layout]="layout"></app-product-card-new>
                        </div>
                    </div>
                </ng-template>
            </owl-carousel-o>
        </div>
    </div>
</div>
<!-- .block-products-carousel / end -->
